import { useState } from 'react';
import { endCenterViewSessionAPI } from '../../api/superAdminAuth';
import { clearCenterViewSession, getCenterViewSession } from '../../lib/utils';
import { CENTER_VIEW_BANNER_HEIGHT } from '../../context/AccessModeContext';

const CenterViewBanner = () => {
    const session = getCenterViewSession();
    const authObject = session?.authObject;
    const [isEnding, setIsEnding] = useState(false);

    if (!session || !authObject) return null;

    const endView = async () => {
        if (isEnding) return;
        setIsEnding(true);
        try {
            if (authObject.viewSessionId) {
                await endCenterViewSessionAPI(authObject.viewSessionId, session.authorization, 'explicit');
            }
        } catch {
            // 종료 기록 실패가 로컬 열람 세션 종료를 막아서는 안 된다.
        } finally {
            clearCenterViewSession(true);
            window.close();
            window.setTimeout(() => window.location.replace('/superadmin'), 100);
        }
    };

    return (
        <div
            role="status"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: CENTER_VIEW_BANNER_HEIGHT,
                zIndex: 10000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 9,
                background: '#FFF4D6',
                borderBottom: '1px solid #E5C66A',
                color: '#604B10',
                fontSize: 13,
                fontWeight: 600,
                boxShadow: '0 2px 8px rgba(96,75,16,0.12)',
            }}
        >
            <span aria-hidden="true">🔒</span>
            <span>{authObject.centerName || '선택한 센터'}를 읽기 전용으로 열람 중입니다.</span>
            <button
                type="button"
                onClick={endView}
                disabled={isEnding}
                style={{
                    border: '1px solid #9A7817',
                    borderRadius: 7,
                    background: '#fff',
                    color: '#604B10',
                    padding: '3px 9px',
                    fontSize: 11,
                    fontWeight: 700,
                    cursor: isEnding ? 'wait' : 'pointer',
                }}
            >
                {isEnding ? '종료 중' : '열람 종료'}
            </button>
        </div>
    );
};

export default CenterViewBanner;
